
interface LogEntry {
  level: 'info' | 'warn' | 'error' | 'debug';
  message: string;
  context?: Record<string, any>;
  timestamp: string;
  userId?: string;
  sessionId?: string;
}

class ProductionLogger {
  private isDevelopment = import.meta.env.DEV;
  private logQueue: LogEntry[] = [];

  private createLogEntry(level: LogEntry['level'], message: string, context?: Record<string, any>): LogEntry {
    return {
      level,
      message,
      context,
      timestamp: new Date().toISOString(),
      userId: undefined,
      sessionId: sessionStorage.getItem('session_id') || undefined
    };
  }

  info(message: string, context?: Record<string, any>) {
    const entry = this.createLogEntry('info', message, context);
    
    if (this.isDevelopment) {
      console.info(`[${entry.level.toUpperCase()}]`, entry.message, entry.context || '');
    }
  }

  warn(message: string, context?: Record<string, any>) {
    const entry = this.createLogEntry('warn', message, context);
    
    if (this.isDevelopment) {
      console.warn(`[${entry.level.toUpperCase()}]`, entry.message, entry.context || '');
    }
  }

  error(message: string, context?: Record<string, any>) {
    const entry = this.createLogEntry('error', message, context);
    
    // Always log errors
    console.error(`[${entry.level.toUpperCase()}]`, entry.message, entry.context || '');
  }

  debug(message: string, context?: Record<string, any>) {
    if (this.isDevelopment) {
      const entry = this.createLogEntry('debug', message, context);
      console.debug(`[${entry.level.toUpperCase()}]`, entry.message, entry.context || '');
    }
  }

  cleanup() {
    // Clear the log queue
    this.logQueue = [];
    
    // Any other cleanup operations can be added here
    if (this.isDevelopment) {
      console.debug('[LOGGER] Cleanup completed');
    }
  }
}

export const logger = new ProductionLogger();
